import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { SelectCentroCosto } from 'sharedComponents/select'

import { KeyEventUtil } from 'utils'

const CentroCostoNivel1FormGroup = ({ iError, iTouched, fIsSubmitting, setFieldValue }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('select-centroCostoNivel2', e)
  }, [])

  const oneRowTrigger = React.useCallback(
    primeraFila => {
      setFieldValue('_idCentroCostoNivel1', primeraFila._id)
    },
    [setFieldValue]
  )

  return (
    <Form.Group>
      <Form.Label text='C. COSTO 1' htmlFor='select-centroCostoNivel1' md={3} alignRightAt='md' />
      <Col md={9}>
        <Field name='_idCentroCostoNivel1'>
          {({ field }) => (
            <SelectCentroCosto
              {...field}
              id='select-centroCostoNivel1'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onKeyDown={onKeyDown}
              nivel={1}
              oneRowTrigger={oneRowTrigger}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CentroCostoNivel1FormGroup)
